import { h } from 'preact';
import { Text } from 'preact-i18n';

import { formatCatchHeadline } from '../../lib/fishCatch';
import { EntryDetails, EntryPosition } from '../fishEntry/entryCardParts';

// NB: `catch` is a JS reserved word — every identifier here uses the
// fishCatch prefix, matching the convention set in lib/fishCatch.js and
// components/fishCatch/drawer.js.
//
// Everything shared with the contact card (weather icon table, detail row,
// position row) lives in fishEntry/entryCardParts.js. This file carries only
// what is catch-specific: the headline, the fish icon and the released badge.
function FishCatchCard({ fishCatch }) {
    if (!fishCatch) {
        return null;
    }

    const headline = formatCatchHeadline(fishCatch);
    const photo = fishCatch.images?.[0]?.s3MediumLink;

    return (
        <div class='card mb-2'>
            {photo && (
                <img src={photo} class='img-fluid rounded' alt={headline || ''} />
            )}
            <div class='card-body'>
                <div class='d-flex align-items-center justify-content-between flex-wrap gap-2'>
                    <span class='fw-bold'>
                        <i class='fa-solid fa-fish me-2' />
                        {headline}
                    </span>
                    {fishCatch.released === true && (
                        <span class='badge text-bg-secondary'>
                            <Text id='fishCatch.released'>Released</Text>
                        </span>
                    )}
                </div>

                <EntryDetails entry={fishCatch} />
                <EntryPosition entry={fishCatch} />
            </div>
        </div>
    );
}

export default FishCatchCard;
